import { createSelector } from "reselect";
import { filter } from "lodash-es";
import featuresSelector from "./featuresSelector";
function proteinDomainFeaturesRawSelector(features) {
  return filter(
    features,
    ({ type }) => type && type.toUpperCase() === "PROTEIN_DOMAIN"
  );
}
export default createSelector(
  featuresSelector,
  proteinDomainFeaturesRawSelector
);
